import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { StandardFiltersComponent } from './standard-filters/standard-filters.component';
import { CommercialFiltersComponent } from './commercial-filters/commercial-filters.component';

import { CheckboxModule } from '../forms/checkbox/checkbox.module';
import { SwitchModule } from '../forms/switch/switch.module';
import { SelectModule } from '../forms/select/select.module';
import { RadioGroupModule } from '../forms/radio-group/radio-group.module';

import { SharedPipesModule } from '../../shared/pipes/shared-pipes.module';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        CheckboxModule,
        SelectModule,
        SwitchModule,
        RadioGroupModule,
        TranslateModule.forChild(),
        SharedPipesModule
    ],
    declarations: [
        StandardFiltersComponent,
        CommercialFiltersComponent
    ],
    exports: [
        StandardFiltersComponent,
        CommercialFiltersComponent
    ]
})
export class FiltersModule { }
